module.exports = __webpack_public_path__ + "img/960.748254bd.svg";